export default {"src":"/_next/static/media/Avatar group.934df7ad.svg","height":56,"width":120,"blurWidth":0,"blurHeight":0};